import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { sagaLoadApps } from '../actions';

// React UI
import { Button } from 'antd';

class AppListItem extends Component{
  onSelect(){
    this.props.onClick();
  }
  render(){
    const textColor = !this.props.active ? '#212121' : '#3D5AFE';
    return(
      <a href="" style={{ textDecoration: 'none' }}onClick={(e) => {
        this.onSelect();
        e.preventDefault();
      }}>
        <div style={{
            color: textColor,
          }}>
            <small>{this.props.app.name}</small>
            <p>{this.props.app.packageName}</p>
          </div>
        </a>
      )
  }
}

AppListItem.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func,
  app: PropTypes.shape({
    name: PropTypes.string,
    packageName: PropTypes.string,
  }),
}

AppListItem.defaultProps = {
  active: false,
}

// AppsSidebar

class AppsSidebar extends Component {
  componentDidMount() {
    this.props.loadApps();
  }
  onCreateApp(){
    this.props.history.push('/apps/create');
  }

  render() {
      var self = this;
      let activeAppId = this.props.match.params.app_id || null;

      return (
        <div>
        <div className="sidebar-info">
          <div className="sidebar-inner">
            <h4 className="heading-level-1">Apps</h4>
          </div>
        </div>
        <div className="sidebar-inner">
          <div>
            {this.props.appIDs.map((appID, index)=>{
              let app = self.props.appsMap[appID];
              return (
                <AppListItem 
                  app={app} 
                  key={index} 
                  onClick={()=>{
                    this.props.history.push('/apps/'+ app._id);
                  }} 
                  active={(activeAppId === app._id)}
                />
              )
            }
            )}
          </div>
          <Link to="/createApp">
              <Button icon="plus" type="primary" style={{ width: '100%' }}>Create App</Button>
          </Link>
        </div>
        </div>
      );
    }
}

AppsSidebar.propTypes = {
  appIDs: PropTypes.array,
  onClick: PropTypes.func,
  loadApps: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      'app_id': PropTypes.string,
    })
  })
}


AppsSidebar.defaultProps = {
  apps: []
}

// Map props to the store

const mapStateToProps = (state) => ({
  appIDs: state.routes.apps.get('appIDs').toArray(),
  appsMap: state.routes.apps.get('appsMap').toObject(),
});

const mapDispatchToProps = (dispatch) => ({
  loadApps: ()=>{
    dispatch(sagaLoadApps());
  }
});

const AppsSidebarContainer = connect(mapStateToProps,mapDispatchToProps)(AppsSidebar);

export default AppsSidebarContainer;


// WEBPACK FOOTER //
// ./src/apps/components/AppsSidebar.js